const customTitles = {
  // Videos
  'drinks.mp4': 'Organic Kombucha Juice',
  'Sharv.mp4': 'Sharv',
  'clothing.mp4': 'Red Clothing Showcase',
  'amrut-atta.mp4': 'Amrut Atta Campaign',
  'gusbmps_Ai_Video.mp4': 'Gusbumps',
  'Punjab-Demo.mp4': 'Model Clothing',
  'Farmhands.mp4': 'Farmhands',
  'jewellery.mp4': 'Luxury Jewellery Showcase',
  'nucc.mp4': 'Nucc Juice Commercial',
  'red-wine-soap-ugc.mp4': 'Red Wine Soap UGC Video',
  'redwine-soap.mp4': 'Red Wine Soap Production',
  'rock-and-roll.mp4': 'Dynamic Rock & Roll Promo',
  'trip.mp4': 'Adventure Trip Cinematic',

  // Model Shoot
  '1.jpg': 'Elegance Portrait',
  '2.jpg': 'Graceful Smile Portrait',
  'model/3.jpg': 'Chic Side Profile Elegance',
  '4.jpg': 'Golden Crown Pendant & Jhumka Detail',
  '5.jpg': 'Luxury Sapphire & Diamond Portrait',
  'model/6.jpg': 'Sapphire Choker & Earring Detail',
  'Indian_female_model_in_her_202605151737.jpeg': 'Red Bridal Saree & Gemstone Necklace',
  'Model_twirling_fabric_flowing_ou…_202605151732.jpeg': 'Fuchsia Silk Saree Elegance',
  'Model_twirling_fabric_flowing_ou 2605151732.jpeg': 'Fuchsia Silk Saree Elegance',
  'Use_the_provided_reference_image_202605151732.jpeg': 'Classic Fuchsia Saree Poised Pose',
  'Use_the_provided_reference_image_202605151732 (1).jpeg': 'Zari Border & Gold Bangles Detail',

  // Product Shoot
  'product/3.jpg': 'Arus Homemaker Chakli Flavors Trio',
  'product/6.jpg': 'Arus Peri Peri Chakli & Hot Mug Setup',
  '7.jpg': 'Arus Peri Peri Chakli with Fresh Spices',
  '7 (1).jpg': 'Arus Chaat Masala Chakli Snack Layout',
  '9.jpg': 'Arus Chakli Trio Windowsill Showcase',
  '11.jpg': 'Arus Classic Chakli Product Portrait',
  '0990d315-e863-4d64-b9b1-e580ea19d26d.png_202605151739.jpeg': 'Jiva Aloe Vera Face Wash Pedestal Shot',
  'Red-Wine-Soap.jpg_202605141929.jpeg': 'Lite Natures Handcrafted Redwine Soap',
  'Untitled design.jpg': 'Diamond & Sapphire Necklace Bust Display',
  'Untitled design (1).jpg': 'Diamond & Sapphire Necklace Three-Quarter View',
  'gold_necklace_and_earrings_displayed_202605151736.jpeg': 'Amethyst Purple Gemstone & Gold Jewelry Set',
  'Use_the_provided_reference_image_202605151734.jpeg': 'High-Performance Athletic Running Shoes',
  'Use_the_provided_reference_image_202605151734 (1).jpeg': 'Athletic Running Shoes on Reflective Marble',
  '_USE_PROVIDED_IMAGE_AS_REFERENCE__202605151740.jpeg': 'Jiva Aloe Vera Face Wash Stone Slab Display'
};

export function toTitleFromFileName(fileName, src) {
  if (!fileName) return '';

  const cleanName = fileName.trim();

  // Try category-prefixed keys if src is provided
  if (src && typeof src === 'string') {
    const lowerSrc = src.toLowerCase();
    if (lowerSrc.includes('model shoot')) {
      const modelKey = `model/${cleanName}`;
      if (customTitles[modelKey]) {
        return customTitles[modelKey];
      }
    } else if (lowerSrc.includes('product shoot')) {
      const productKey = `product/${cleanName}`;
      if (customTitles[productKey]) {
        return customTitles[productKey];
      }
    }
  }

  // Fallback to absolute cleanName match
  if (customTitles[cleanName]) {
    return customTitles[cleanName];
  }

  // Fallback to formatting
  const withoutExt = cleanName.replace(/\.[^/.]+$/, '');
  const normalized = withoutExt.replace(/[-_]+/g, ' ');
  const collapsed = normalized.replace(/\s+/g, ' ').trim();

  return collapsed
    .split(' ')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function getFilesFromBuildTimeList(items) {
  return Array.isArray(items) ? items : [];
}


